
/**
 * Default time range available for selection
 */

export const TIME_RANGE = {
    min: 1800,
    max: new Date().getFullYear()
}

// use different time window for FUNGUS (1991) and LICHEN (1989) applications.
// this reflects the time range where most of the currenly available data has been collected.
export const SELECTED_TIME_SPAN_LICHEN = {
    min: 1989,
    max: new Date().getFullYear()
}

export const SELECTED_TIME_SPAN_FUNGUS = {
    min: 1991,
    max: new Date().getFullYear()
}

export const FUNGUS_APP_NAME = 'FUNGUS'

export const LICHEN_APP_NAME = 'LICHEN'

export const COLOR_SCHEME = {

    // initial color scheme
    // app_lightyellow: '#dae899',
    // app_dark_red: '#718E5B',
    // app_dark_yellow: '#11378e',
    // app_dark_yellow: '#ffd100', // WSL yellow
    // app_green '#006666', // WSL red
    // app_lightyellow: '#fdf5c9', // WSL lightyellow


    // WSL corporate design color scheme
    app_dark_red: '#970e36',//'#ffd100',
    // app_orange '#FB8E00',//'#ffd100',
    app_light_red: '#ff8f8f',//'#ffd100',
    app_lightyellow: '#fdf5c9', // #fdf5c9
    app_dark_yellow: '#ffd100',
    app_grey: '#c4c0ba',
    app_lightgrey: '#f2f2f2',
    app_dark: '#424242',
    app_highlighted: '#970e36',
    app_font: 'Libre Franklin'
}

export const API_ERROR_MESSAGE = 'Could not retrieve data via api: '
export const URL_ERROR_MESSAGE = 'Could not parse URL pattern: '
export const OBSERVATION_ERROR_MESSAGE = 'No observations found at these coordinates. '
export const CONFIG_ERROR_MESSAGE = 'Please choose app-config: [ LICHEN | FUNGUS ] '